export default __webpack_public_path__ + "static/screenshot-timeseries-chart-76e9e97353e4cf2d83fae46411dcce4d.webp";